export default function CTA() {
  return (
    <section id="contact" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-16">
          <h2 className="text-6xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            あなたのプロジェクトを<br />
            一緒に実現しませんか？
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            まずはお気軽にご相談ください。初回相談は無料です。
          </p>
          <a href="#contact-form" className="inline-flex items-center gap-2 px-10 py-5 bg-gray-900 text-white text-lg font-medium rounded-full hover:bg-gray-800 transition-all hover:shadow-xl whitespace-nowrap cursor-pointer">
            無料相談を予約する
            <i className="ri-arrow-right-line text-2xl"></i>
          </a>
        </div>

        <div className="bg-gradient-to-br from-rose-50 to-orange-50 rounded-3xl p-12 mb-16">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-md">
                <i className="ri-mail-line text-3xl text-rose-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                メールでのお問い合わせ
              </h3>
              <p className="text-sm text-gray-600 mb-3">
                24時間受付、1営業日以内に返信
              </p>
              <a href="mailto:info@e-shigoto.jp" className="text-sm font-medium text-rose-600 hover:text-rose-700 cursor-pointer">
                info@e-shigoto.jp
              </a>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-md">
                <i className="ri-phone-line text-3xl text-orange-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                お電話でのお問い合わせ
              </h3>
              <p className="text-sm text-gray-600 mb-3">
                平日 10:00〜18:00
              </p>
              <a href="tel:0312345678" className="text-sm font-medium text-orange-600 hover:text-orange-700 cursor-pointer">
                03-1234-5678
              </a>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-md">
                <i className="ri-video-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                オンライン相談
              </h3>
              <p className="text-sm text-gray-600 mb-3">
                Zoom・Google Meet対応
              </p>
              <a href="#contact-form" className="text-sm font-medium text-teal-600 hover:text-teal-700 cursor-pointer">
                予約する
              </a>
            </div>
          </div>
        </div>

        <div id="contact-form" className="max-w-3xl mx-auto bg-white rounded-3xl shadow-xl p-12">
          <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            お問い合わせフォーム
          </h3>
          
          <form 
            action="https://readdy.ai/api/form/d6h57gecjgvlppf404a0"
            method="POST"
            data-readdy-form
            className="space-y-6"
            onSubmit={(e) => {
              e.preventDefault();
              const form = e.currentTarget;
              const formData = new FormData(form);
              
              fetch(form.action, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams(formData as any).toString()
              })
              .then(response => {
                if (response.ok) {
                  alert('お問い合わせありがとうございます。1営業日以内にご返信いたします。');
                  form.reset();
                } else {
                  alert('送信に失敗しました。もう一度お試しください。');
                }
              })
              .catch(() => {
                alert('送信に失敗しました。もう一度お試しください。');
              });
            }}
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                  お名前 <span className="text-rose-600">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-rose-500 focus:border-transparent outline-none transition-all"
                  placeholder="山田 太郎"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                  メールアドレス <span className="text-rose-600">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-rose-500 focus:border-transparent outline-none transition-all"
                  placeholder="example@email.com"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2">
                  会社名・団体名
                </label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-rose-500 focus:border-transparent outline-none transition-all"
                  placeholder="株式会社〇〇"
                />
              </div>

              <div>
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                  電話番号
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-rose-500 focus:border-transparent outline-none transition-all"
                  placeholder="03-1234-5678"
                />
              </div>
            </div>

            <div>
              <label htmlFor="service" className="block text-sm font-medium text-gray-700 mb-2">
                ご希望のサービス <span className="text-rose-600">*</span>
              </label>
              <select
                id="service"
                name="service"
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-rose-500 focus:border-transparent outline-none transition-all cursor-pointer"
              >
                <option value="">選択してください</option>
                <option value="ブランドイラストレーション">ブランドイラストレーション</option>
                <option value="書籍・出版イラスト">書籍・出版イラスト</option>
                <option value="Webサイトイラスト">Webサイトイラスト</option>
                <option value="広告・キャンペーンビジュアル">広告・キャンペーンビジュアル</option>
                <option value="キャラクターデザイン">キャラクターデザイン</option>
                <option value="パッケージイラスト">パッケージイラスト</option>
                <option value="その他">その他</option>
              </select>
            </div>

            <div>
              <label htmlFor="budget" className="block text-sm font-medium text-gray-700 mb-2">
                ご予算
              </label>
              <select
                id="budget"
                name="budget"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-rose-500 focus:border-transparent outline-none transition-all cursor-pointer"
              >
                <option value="">選択してください</option>
                <option value="〜10万円">〜10万円</option>
                <option value="10万円〜30万円">10万円〜30万円</option>
                <option value="30万円〜50万円">30万円〜50万円</option>
                <option value="50万円〜100万円">50万円〜100万円</option>
                <option value="100万円以上">100万円以上</option>
                <option value="未定">未定</option>
              </select>
            </div>

            <div>
              <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                お問い合わせ内容 <span className="text-rose-600">*</span>
              </label>
              <textarea
                id="message"
                name="message"
                required
                rows={6}
                maxLength={500}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-rose-500 focus:border-transparent outline-none transition-all resize-none"
                placeholder="プロジェクトの詳細、ご希望の納期、その他ご質問などをご記入ください（500文字以内）"
              ></textarea>
              <p className="text-xs text-gray-500 mt-2">※500文字以内でご記入ください</p>
            </div>

            <button
              type="submit"
              className="w-full px-8 py-4 bg-gray-900 text-white text-lg font-medium rounded-lg hover:bg-gray-800 transition-all hover:shadow-lg whitespace-nowrap cursor-pointer"
            >
              送信する
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}